const phoneErrorRegex = /^Phone No.*already in use.*/;

export const isPhoneUpdateError = (error: string) => {
    return phoneErrorRegex.test(error);
};

export const isUpdateRetryError = (error: string) => {
    return error.includes('GetAllExtendedMemberData failed to get data');
};

export const isADB2CEmailCreateError = (error: string) => {
    return error.includes('Another object with the same value for property');
};
export const isADB2CPasswordCreateError = (error: string) => {
    return error.includes('The specified password does not comply with password complexity');
};
